import BaseButton, { ButtonProps as ButtonBaseProps } from '@material-ui/core/Button'
import React, { PropsWithChildren } from 'react'
import styled, { css } from 'styled-components'
import { Icon, IconProps } from '../icon/icon'
import { hoverStylesBlack, hoverStylesCta, hoverStylesDark, hoverStylesGreen, hoverStylesOrange } from './buttonHover'
import { irem } from '../../utils'

export type ButtonTypeProps = 
  // Default
  | { primary: true; secondary?: never; buttonColor: string;  text?: never; dark?: never; cta?: never; icon?: IconProps['icon'] }
  // Primary 
  | { primary?: false; secondary: true; buttonColor: string;  text?: never; dark?: never; cta?: never; icon?: IconProps['icon'] }
  // Secondary
  | { primary?: false; secondary?: false; buttonColor?: never;  text: true; dark?: never; cta?: never; icon?: IconProps['icon']}
  // Text Button
  | { primary?: false; secondary?: false; buttonColor?: never;  text?: never; dark: true; cta?: never; icon?: IconProps['icon'] }
  // Dark Background Button
  | { primary?: false; secondary?: false; buttonColor?: never;  text?: never; dark?: never; cta: true; icon?: IconProps['icon']  }

export type ButtonProps = ButtonBaseProps & ButtonTypeProps & { target?: string }

export const StyledButton = styled(BaseButton)<{ $cta?: boolean }>`
  ${props => props.variant === 'outlined' && props.color === 'default' && hoverStylesBlack}
  ${props => props.variant === 'outlined' && props.color === 'primary' && hoverStylesOrange}
  ${props => props.variant === 'outlined' && props.color === 'secondary' && hoverStylesGreen}
  ${props => props.variant === 'contained' && props.color === 'primary' && hoverStylesCta}
  ${props => props.variant === 'contained' && props.color === 'secondary' && hoverStylesDark}
    
  ${props => props.$cta && css`
      display: inline-flex;
      padding: ${irem(16)} ${irem(30)};
      border-radius: ${irem(5)};
      font-size: ${irem(16)};
      background: #CC2605;
  `}
`
export const ButtonIcon = styled(Icon)`
  height: ${props => props.theme.typography.pxToRem(16)};
  width: ${props => props.theme.typography.pxToRem(16)};
  fill: ${props => props.theme.palette.primary.main};
  background: none;

  &:hover {
    fill: ${props => props.theme.palette.secondary.dark};
  }
`

export const ArrowNavButton = styled(BaseButton)`
    border: 1px solid currentColor;
    height: ${irem(48)};
    width: ${irem(69)};
    font-size: ${irem(18.5)};
    transition-duration: 0.1s;
    transition-timing-function: ease-in-out;
    transition-property: color, border-color;

    svg {
        font-size: 1em;
    }
    
    & + & {
        margin-left: ${irem(7)};
    }
    
    &:hover, &:focus {
        background: transparent;
        color: ${props => props.theme.custom.colors.darkRed};
    }
`

export const Button: React.FC<PropsWithChildren<ButtonProps>> = ({ primary, secondary, buttonColor, text, dark, cta, icon,  ...buttonProps }) => {
  buttonProps.variant = cta ? 'contained' : (text ? 'text' : 'outlined')

  if (primary) {
    switch (buttonColor) {
    case 'black':
      buttonProps.color= 'default'
      break
    case 'orange':
      buttonProps.color = 'primary'
      break
    case 'green':
      buttonProps.color = 'secondary'
      break
    }
  }

  if (secondary) {
    buttonProps.size = 'small'

    switch (buttonColor) {
    case 'black':
      buttonProps.color= 'default'
      break
    case 'orange':
      buttonProps.color = 'primary'
      break
    case 'green':
      buttonProps.color = 'secondary'
      break
    }
  }

  if (cta) {
    buttonProps.color= 'primary'
  }

  if (dark) {
    buttonProps.variant = 'contained'
    buttonProps.color= 'secondary'
  }

  if (text) {
    buttonProps.color = 'primary'
  }

  if (icon) {
    buttonProps.endIcon = <ButtonIcon icon={icon}></ButtonIcon>
  }

  return (
    <StyledButton $cta={cta} aria-label={buttonProps.children ? buttonProps.children as string : ''} { ...buttonProps } />
  )
}